// extracted by mini-css-extract-plugin
export var emailBlockLink = "_q7-0";